import React from 'react';
import { Card } from '../ui/Card';
export function MapLegend() {
  return <Card className="absolute bottom-6 left-6 z-[400] w-64 !p-4 shadow-float border-0 bg-white/95 backdrop-blur-sm" data-id="element-128">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-129">
        Bewertungs-Score
      </h4>

      <div className="space-y-3" data-id="element-130">
        <div className="flex items-center justify-between" data-id="element-131">
          <div className="flex items-center gap-2" data-id="element-132">
            <div className="w-3 h-3 rounded-full bg-status-success shadow-[0_0_8px_rgba(34,197,94,0.4)]" data-id="element-133"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-134">
              Exzellent (&gt;4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-135">842</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-136">
          <div className="flex items-center gap-2" data-id="element-137">
            <div className="w-3 h-3 rounded-full bg-status-warning shadow-[0_0_8px_rgba(234,179,8,0.4)]" data-id="element-138"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-139">
              Durchschnitt (3.5-4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-140">126</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-141">
          <div className="flex items-center gap-2" data-id="element-142">
            <div className="w-3 h-3 rounded-full bg-status-danger shadow-[0_0_8px_rgba(239,68,68,0.4)]" data-id="element-143"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-144">
              Kritisch (&lt;3.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-145">12</span>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100" data-id="element-146">
        <div className="text-xs text-gray-500" data-id="element-147">
          <span className="font-medium text-edeka-blue" data-id="element-148">12 Märkte</span> im
          kritischen Bereich erfordern Aufmerksamkeit.
        </div>
      </div>
    </Card>;
}